import { render } from "./ForgotPasPCZ.vue?vue&type=template&id=22d4955d"
const script = {}

import exportComponent from "/var/www/vhosts/hypergen.be/pcz.hypergen.be/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__